import { RouteObject } from 'react-router-dom'
import { ProtectedRoute } from 'lib/rbac'

export const creditNotesRoutes = (basePath = 'credit-notes'): RouteObject[] => [
  {
    path: basePath,
    children: [
      {
        index: true,
        lazy: async () => {
          const { default: CreditNotesRoute } = await import(
            './CreditNotesRoute'
          )
          return {
            Component: () => (
              <ProtectedRoute permission="org.creditNote:read">
                <CreditNotesRoute />
              </ProtectedRoute>
            )
          }
        }
      },
      {
        path: ':creditNoteId',
        lazy: async () => {
          const { default: CreditNoteDetailRoute } = await import(
            './CreditNoteDetailRoute'
          )
          return {
            Component: () => (
              <ProtectedRoute permission="org.creditNote:read">
                <CreditNoteDetailRoute />
              </ProtectedRoute>
            )
          }
        }
      }
    ]
  }
]
